"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PTxId = void 0;
var pstruct_1 = require("../../../PTypes/PStruct/pstruct.js");
var types_1 = require("../../../type_system/types.js");
// plutarch implementation https://github.com/Plutonomicon/plutarch-plutus/blob/f0805033ec7ad83643ba3c90902673ba6e5b90c3/Plutarch/Api/V1/Tx.hs#L39
// no idea why this is not an alias
exports.PTxId = (0, pstruct_1.pstruct)({
    PTxId: { txId: types_1.bs }
});
